<template>
  <div :class="`button-filter ${blink ? 'animate-blinking' : ''}`">
    <router-link v-if="!blink" :to="filterUrl">
      <div class="filter-content">
        <p class="text-base font-semibold">Filtres</p>
        <FilterNumberTag>{{ filtersNumber }}</FilterNumberTag>
      </div>
    </router-link>
  </div>
</template>

<script>
import FilterNumberTag from './FilterNumberTag.vue'

export default {
  name: 'ButtonFilter',
  components: {
    FilterNumberTag
  },
  props: {
    stringifiedFilters: {
      type: String,
      default: ''
    },
    filtersNumber: {
      type: Number,
      default: 0
    },
    blink: {
      type: Boolean,
      default: false
    },
    subject: {
      type: String,
      default: 'PropertyPortfolio'
    }
  },
  computed: {
    filterUrl() {
      // Les filtres sont lus depuis localStorage par la page de filtres,
      // il n'est plus nécessaire de les passer dans l'URL.
      return `/filters?subject=${this.subject}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import './ButtonFilter.scss';
</style>
